export const StatusType = {
    /** 신규주문 (=결제완료) */
    NEW_ORDER: 'NEW_ORDER',
    /** 결제대기중 */
    PAYMENT_WAITING: 'PAYMENT_WAITING',
    /** 결제완료 */
    PAYED: 'PAYED',

    /** 발송지연 */
    DELAYED_DISPATCH: 'DELAYED_DISPATCH',
    /** 배송준비중 */
    DELIVERY_READY: 'DELIVERY_READY',
    /** 배송중 */
    DELIVERING: 'DELIVERING',
    /** 배송완료 */
    DELIVERED: 'DELIVERED',

    /** 구매확정완료 */
    PURCHASE_DECIDED: 'PURCHASE_DECIDED',
    /** 구매확정연장 */
    PURCHASE_CONFIRM_EXTENDED: 'PURCHASE_CONFIRM_EXTENDED',

    /** 취소요청 */
    CANCEL_REQUEST: 'CANCEL_REQUEST',
    /** 취소중 */
    CANCELING: 'CANCELING',
    /** 취소완료 */
    CANCELED: 'CANCELED',
    /** 미결제취소완료 */
    UNPAID_CANCELLATION: 'UNPAID_CANCELLATION',
    /** 부분취소 */
    PARTIALLY_CANCELLED: 'PARTIALLY_CANCELLED',
    /** 직권취소중 */
    CANCELING_BY_ADMIN: 'CANCELING_BY_ADMIN',
    /** 직권취소완료 */
    CANCELLED_BY_ADMIN: 'CANCELLED_BY_ADMIN',

    /** 반품요청 */
    RETURN_REQUEST: 'RETURN_REQUEST',
    /** 반품중 */
    RETURNING: 'RETURNING',
    /** 반품수거완료 */
    RETURN_PICKED_UP: 'RETURN_PICKED_UP',
    /** 반품환불완료 */
    RETURN_REFUND: 'RETURN_REFUND',

    /** 교환요청 */
    EXCHANGE_REQUEST: 'EXCHANGE_REQUEST',
    /** 교환중 */
    EXCHANGING: 'EXCHANGING',
    /** 교환수거완료 */
    EXCHANGE_PICKED_UP: 'RETURN_PICKED_UP',
    /** 교환재배송중 */
    EXCHANGE_DELIVERING: 'EXCHANGE_DELIVERING',
    /** 교환완료 */
    EXCHANGED: 'EXCHANGED',

    /** 정산완료 */
    SETTLEMENT_COMPLETED: 'SETTLEMENT_COMPLETED',
    /** 정산예정 */
    SETTLEMENT_SCHEDULED: 'SETTLEMENT_SCHEDULED',
    /** 정산취소완료 */
    SETTLEMENT_CANCELLED: 'SETTLEMENT_CANCELLED',
    /** 정산취소중 */
    SETTLEMENT_CANCELLING: 'SETTLEMENT_CANCELLING',

    /** 알수 없음 */
    UNKNOWN: 'UNKNOWN',
} as const

export type Status = {
    /** 타입 */
    type: Constant<typeof StatusType>
    /** 이름 */
    name: string
    /** 설명 */
    description?: string
}
